// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckboxWidget_checkbox__OzN3a","is_large":"CheckboxWidget_is_large__EuoNt"};